import { render, staticRenderFns } from "./RouteBadge.vue?vue&type=template&id=05b4e35c&scoped=true&"
import script from "./RouteBadge.vue?vue&type=script&lang=js&"
export * from "./RouteBadge.vue?vue&type=script&lang=js&"
import style0 from "./RouteBadge.vue?vue&type=style&index=0&id=05b4e35c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05b4e35c",
  null
  
)

export default component.exports